import { CellContext } from '@tanstack/react-table';
import { SmallPortalTooltip } from '../../Tooltip';
import { TooltipContent, TooltipDetail, TooltipTitle } from './Tooltip';
import styled from 'styled-components';
import { CompanyResponse } from '../../../api/admin';
import { LearnerProgress } from '.';

const RatingContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StarIcon = styled.i`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 15px;
  margin-right: 2px;
`;

const ItemName = styled.span`
  font-style: italic;
  color: ${({ theme }) => theme.colors.textActive};
`;

const RatingStars: React.FC<{ rating: number; maxStars?: number }> = ({
  rating,
  maxStars = 5,
}) => {
  return (
    <RatingContainer>
      {[...Array(maxStars)].map((_, index) => {
        let starClass = 'fa-regular fa-star';
        if (rating >= index + 1) {
          starClass = 'fa-solid fa-star';
        } else if (rating >= index + 0.5) {
          starClass = 'fa-solid fa-star-half-stroke';
        }
        return <StarIcon key={index} className={starClass} />;
      })}
    </RatingContainer>
  );
};
export default function DifficultyCell(
  info: CellContext<
    LearnerProgress,
    CompanyResponse['cohorts'][number]['learners'][number]['progress']['difficulty']
  >
) {
  const value = info.getValue()?.average;

  if (!value) {
    return <div style={{ textAlign: 'right' }}>-</div>;
  }

  const uniqueId = `avg-difficulty-tooltip-${info.row.id}`;

  return (
    <div
      data-tooltip-id={uniqueId}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      <RatingStars rating={value} />
      <SmallPortalTooltip anchorSelect={`[data-tooltip-id="${uniqueId}"]`}>
        <TooltipContent>
          <TooltipTitle>Average Difficulty</TooltipTitle>
          <TooltipDetail>{value.toFixed(1)}</TooltipDetail>
          <TooltipTitle style={{ marginTop: 16 }}>Breakdown</TooltipTitle>
          {info.row.original.progress.difficulty.items.map((item, index) => (
            <TooltipDetail key={item.name}>
              {index + 1}. <ItemName>{item.name}</ItemName>:{' '}
              {item.difficultyRating}/5
            </TooltipDetail>
          ))}
        </TooltipContent>
      </SmallPortalTooltip>
    </div>
  );
}
